import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ResponsiveContext, Button, Layer, Text, Box, Anchor } from 'grommet';
import { FormClose } from 'grommet-icons';

import { ErrorForm } from '../../../../components';
import { TitleDetail } from '../../../../components/detail';

import { searchExpenses } from '../../actions/form-search';
import { remove, toggleFormDeleteLayer } from '../../actions/form-delete';

import visibleWidth from '../../../../constants/layer-width';

import { formattedCurrency } from '../../../../utils';

class FormDelete extends Component {
  callbackPostSuccess = () => {
    const {
      searchExpenses,
      toggleFormDeleteLayer,
    } = this.props;

    searchExpenses();
    toggleFormDeleteLayer();
  };

  handlePost = formParams => {
    const { remove } = this.props;
    remove({
      formParams,
      callbackSuccess: this.callbackPostSuccess,
    });
  };

  render() {
    const {
      id,
      reference,
      categoryName,
      value,

      toggleLayer,
      loadingPostForm,
      postDataError,
      toggleFormDeleteLayer,
    } = this.props;


    if(toggleLayer && toggleLayer === 'delete') {
      return (
        <ResponsiveContext.Consumer>
          {size => (
            <Layer
              responsive={false}
              full='vertical'
              position='left'
              onClickOutside={toggleFormDeleteLayer}
              onEsc={toggleFormDeleteLayer}
            >
              <Box
                fill='vertical'
                width={visibleWidth[size]}
                pad={{ top: 'large', bottom: 'xsmall' }}
                overflow='auto'
                flex
              >
                <Box
                  direction='row'
                  justify='between'
                  align='baseline'
                  margin={{ horizontal: 'large' }}
                >
                  <TitleDetail value='Excluir despesa' />

                  <Button
                    plain
                    title='Fechar'
                    icon={<FormClose />}
                    onClick={toggleFormDeleteLayer}
                  />
                </Box>


                <Box flex overflow='auto'>
                  <Box
                    gap={ size === 'small' ? 'medium' : 'small' }
                    margin={{ vertical: 'small', horizontal: 'large' }}
                    flex={{ shrink: 0 }}
                  >
                    <Text color='dark-2' size='small'>
                      Ao excluir a despesa, todas as informações relacionadas serão perdidas. Após a confirmação, a exclusão será permanente e não poderá ser desfeita.
                    </Text>
                  </Box>


                  <Box
                    flex={{ shrink: 0 }}
                    border={ { color: 'light-5', size: 'xsmall' } }
                    margin={{ vertical: 'small', horizontal: 'large' }}
                    pad={{ horizontal: 'medium', vertical: 'medium' }}
                    round='small'
                    gap='medium'
                  >
                    <Box
                      direction='row'
                      align='baseline'
                      justify='between'
                    >
                      <Text size='small' color='dark-2'>Referência</Text>
                      <Text size='medium' color='dark-4'>{reference}</Text>
                    </Box>

                    <Box
                      direction='row'
                      align='baseline'
                      justify='between'
                    >
                      <Text size='small' color='dark-2'>Categoria</Text>
                      <Text size='medium' color='dark-4'>{categoryName}</Text>
                    </Box>

                    <Box
                      direction='row'
                      align='baseline'
                      justify='between'
                    >
                      <Text size='small' color='dark-2'>Valor</Text>
                      <Text size='medium' color='dark-4'>{formattedCurrency(value)}</Text>
                    </Box>

                    <Box
                      flex={{ shrink: 0 }}
                    >
                      <ErrorForm errorsList={postDataError.errors} />
                    </Box>
                  </Box>
                </Box>


                {/* botoes acao */}
                <Box
                  direction='row'
                  pad={{ vertical: 'medium' }}
                  justify='center'
                  align='center'
                  gap='small'
                >
                  <Box width='xsmall'>
                    <Anchor
                      color='dark-3'
                      label='Cancelar'
                      disabled={ loadingPostForm }
                      onClick={toggleFormDeleteLayer}
                    />
                  </Box>

                  <Box width='small'>
                    <Button
                      color='status-error'
                      primary
                      label={ !loadingPostForm ? 'SIM, Excluir' : 'Excluindo...' }
                      disabled={ loadingPostForm }
                      onClick={() =>
                        this.handlePost({
                          id,
                          reference,
                        })
                      }
                    />
                  </Box>
                </Box>

              </Box>
            </Layer>
          )}
        </ResponsiveContext.Consumer>
      )
    }

    return null;
  }
}

const mapStateToProps = ({
  layerReducer,
  formCreateUpdateCopyGeneric,
 }) => ({
  id: formCreateUpdateCopyGeneric.id,
  reference: formCreateUpdateCopyGeneric.reference,
  categoryName: formCreateUpdateCopyGeneric.categoryName,
  value: formCreateUpdateCopyGeneric.value,

  loadingPostForm: formCreateUpdateCopyGeneric.loadingPostForm,
  postDataError: formCreateUpdateCopyGeneric.postDataError,

  toggleLayer: layerReducer.toggleLayer,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    remove,
    searchExpenses,
    toggleFormDeleteLayer,
  }, dispatch);

export const Delete = connect(mapStateToProps, mapDispatchToProps)(FormDelete);
